import React from 'react'
import { CardNew, Loader } from '@web/walter-ui-kit'

function SkeletonFiat() {
    return (
        <CardNew
            cardHeader={<Loader width={180} height={39} />}
            subHeader={<Loader width={160} height={18} />}
            background="accent"
            dataPointer="fiat_flow_skeleton"
        >
            <Loader borderRadius="s" width="100%" height={66} />
        </CardNew>
    )
}

export default SkeletonFiat
